module.exports = __webpack_public_path__ + "static/img/General Information.77605ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/General Information.png
// module id = kcou
// module chunks = 1